import { useEffect, useState } from 'react';
import CssBaseline from './CssBaseline';

export default function ComponentsOverrides(theme) {
  const [components, setComponents] = useState([]);

  useEffect(() => {
    // Use Webpack's dynamic import to load all .js files in the 'overrides' directory
    // eslint-disable-next-line no-undef
    const componentContext = require.context('./overrides', false, /\.js$/);
    const importedComponents = componentContext.keys().map((filePath) => {
      const componentModule = componentContext(filePath);
      // Assuming each component exports a default component
      return componentModule.default;
    });
    setComponents(importedComponents);
  }, []);

  return Object.assign(CssBaseline(theme), ...components.map((component) => component(theme)));
}
